import { Button } from '@components/ui/button';
import useChat from '@hooks/use-chat';
import { cn, isNovartisInstance } from '@lib/utils';
import { useTranslation } from 'react-i18next';

function LiveChatStatusBar() {
  const { t } = useTranslation();
  const { liveChat } = useChat();

  if (!isNovartisInstance() || !liveChat.enabled || !liveChat.isActive) {
    return null;
  }

  const statusText =
    liveChat.status === 'running' && liveChat.agent?.name
      ? t('chat.live_chat.status_running_agent', { name: liveChat.agent.name })
      : t(`chat.live_chat.status_${liveChat.status}`);

  return (
    <section className="mt-4 flex flex-col gap-3 rounded-2xl border border-[#d8e3ef] bg-white px-4 py-3 text-sm text-[#13233a] shadow-[0_10px_30px_rgba(15,23,42,0.06)] sm:flex-row sm:items-center sm:justify-between">
      <div>
        <div className="font-semibold">{t('chat.live_chat.title')}</div>
        <div className="text-xs text-slate-600">{statusText}</div>
      </div>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className={cn('shrink-0 border-slate-300 text-slate-700')}
        disabled={liveChat.status === 'ending'}
        onClick={() => void liveChat.end()}
      >
        {t('chat.live_chat.button_end')}
      </Button>
    </section>
  );
}

export default LiveChatStatusBar;
